import {Component, OnInit, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap';
import {Router} from '@angular/router';
import {FireBaseService} from '../../../../../common/services/FireBase.service';
import {EvsUserService} from '../../../../../common/services/EvsUser.service';
import {ImportCratingService} from '../../import-crating/services/import-crating.services';
import {ToastrService} from 'ngx-toastr';
import {saveAs} from 'file-saver/FileSaver';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  @ViewChild('notiImport') notiImport: ModalDirective;
  limit: number = 20;
  items: any = [];

  constructor(
    private fbase: FireBaseService,
    private router: Router,
    private evsUserService: EvsUserService,
    private ImportCratingService: ImportCratingService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    let user: any = localStorage.getItem('User');
    if (user) {
      user = JSON.parse(user);
      this.evsUserService
        .getPermissions(user.id)
        .toPromise()
        .then((res: any) => {
          if (!res.error) {
            let roles = res.data.my_permissions;
            let index = roles.indexOf(35);
            if (index > -1) {
              this.getNotification();
            }
          }
        });
    }
  }

  getNotification() {
    this.fbase.getChatInfo().subscribe(numberNotRead => {
      var roomSelect = this.fbase.getIdRoomChat();

      this.fbase.getChatList(this.limit).subscribe(data => {
        let listData: any = [];
        for (let i = data.length - 1; i >= 0; i--) {
          if (data[i]) {
            var time = this.dateBefore(data[i]['timestamp']);
            data[i]['time'] = time;
            listData.push(data[i]);
          }
        }
        this.items = listData
        console.log('vao kokok', this.items)
      });
    });
  }
  loadmore() {
    let lastItem = this.items[this.items.length - 1];
    if (lastItem) {
      this.fbase.loadmore(lastItem.timestamp, this.limit).subscribe(data => {
        let listData: any = [];
        for (let i = data.length - 2; i >= 0; i--) {
          if (data[i]) {
            var time = this.dateBefore(data[i]['timestamp']);
            data[i]['time'] = time;
            listData.push(data[i]);
          }
        }
        this.items = this.items.concat(listData);
      });
    }
    console.log('vao kokok', this.items)
  }
  dateBefore(time: any) {
    var now = new Date().getTime();
    if (now > time) {
      let lineTime = (now - time) / 1000;
      if (lineTime >= 60 && lineTime < 3600) {
        let timeString = (lineTime / 60).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + this.translate.instant('PHUT_TRUOC');
        }
      } else if (lineTime >= 3600 && lineTime < 86400) {
        let timeString = (lineTime / 3600).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + this.translate.instant('GIO_TRUOC');
        }
      } else if (lineTime >= 86400 && lineTime < 604800) {
        let timeString = (lineTime / 86400).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + this.translate.instant('NGAY_TRUOC');
        }
      } else if (lineTime >= 604800) {
        let timeString = (lineTime / 604800).toString().split('.');
        if (timeString.length > 0) {
          return timeString[0] + this.translate.instant('TUAN_TRUOC');
        }
      } else {
        return this.translate.instant('VUA_XONG');
      }
    } else {
      return this.translate.instant('KHONG_XAC_DINH');
    }
  }

  logDataImport = {};

  getNotiImportCrating(id) {
    this.ImportCratingService.getNotifi(id).subscribe((res) => {
      console.log('data', res)
      if (res.code === 1) {
        this.logDataImport = res.data;
        console.log('data', this.logDataImport)
        this.notiImport.show();
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('CANH_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      }), this.closeModalImportFile()
    })

  }

  closeModalImportFile() {
    this.notiImport.hide()
  }

  toPage(item) {
    this.fbase.readed();
    switch (item.target.extraInfo.type) {
      case 1: {
        this.router.navigate(['/qrcode/order']);
        break;
      }
      case 2: {
        this.router.navigate(['/qrcode/order']);
        break;
      }
      case 3: {
        this.router.navigate(['/qrcode/batchstamp/list']);
        break;
      }
      case 4: {
        this.router.navigate(['/qrcode/batchstamp/list']);
        break;
      }
      case 5: {
        this.router.navigate(['/qrcode/withdrawal']);
        break;
      }
      case 6: {
        this.router.navigate(['/qrcode/withdrawal']);
        break;
      }
      case 7: {
        this.router.navigate(['/qrcode/distribution']);
        break;
      }
      case 8: {
        this.router.navigate(['/evs/guarantee/logs']);
        break;
      }
      case 9: {
        this.router.navigate(['/evs/guarantee/logs']);
        break;
      }
      case 10: {
        this.router.navigate(['/evs/guarantee/logs']);
        break;
      }
      case 11: {
        this.router.navigate(['/evs/guarantee/logs']);
        break;
      }
      case 12: {
        this.router.navigate(['/evs/dashboard'], {
          queryParams: { tab: 5 },
        });
        break;
      }
      case 13: {
        this.router.navigate(['/evs/dashboard'], {
          queryParams: { tab: 5 },
        });
        break;
      }
      case 14: {
        this.router.navigate(['/qrcode/batchstamp/list']);
        break;
      }
      case 15: {
        this.router.navigate(['/qrcode/batchstamp/list']);
        break;
      }
      // case 41: {
      //   this.getNotiImportCrating(item.target.id);
      //   break;
      // }
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/notifications/notifications/notifications.component.ts